<template>
  <ClientBadge :client="customer" :label="label" :href="href" :name="name" />
</template>

<script>
import ClientBadge from "./ClientBadge.vue";
import {
  formatCustomerType,
  getClientFullName,
  getCustomerRedirectUrl
} from "./services/client-display.helpers.js";

/**
 * Renders a customer as a ClientBadge, linking to their record.
 * The target route depends on type: partners, resellers, or customers.
 */
export default {
  name: "ShowCustomer",
  components: { ClientBadge },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  computed: {
    /**
     * @returns {string} Customer role label, e.g. "Reseller", "Business"
     */
    label() {
      return formatCustomerType(this.customer && this.customer.type);
    },
    /**
     * @returns {string} Link to the customer's record, empty when unassigned
     */
    href() {
      return this.customer
        ? getCustomerRedirectUrl(this.customer._id, this.customer.type)
        : "";
    },
    /**
     * Business clients show their company name over first/last name.
     * @returns {string} Customer's display name, "Unassigned" when there's no customer
     */
    name() {
      if (this.customer && this.customer.company_name) {
        return this.customer.company_name;
      }
      return getClientFullName(this.customer);
    }
  }
};
</script>
